import { getSessionId } from '@sky-distribution/gp-onboarding-monitoring';
import axios, { AxiosInstance } from 'axios';
import { buildWebStorage, setupCache } from 'axios-cache-interceptor';
import { API_BASE_URL, PRODUCT_ID_HEADER_NAME, SESSION_ID_HEADER_NAME } from '../config/config';

const CACHE_MAX_AGE = 30 * 60 * 1000;

export const api = ({ productId }: { productId: string }): AxiosInstance => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      [SESSION_ID_HEADER_NAME]: getSessionId(),
      [PRODUCT_ID_HEADER_NAME]: productId,
    },
  });

  return setupCache(
    instance, { ttl: CACHE_MAX_AGE, storage: buildWebStorage(sessionStorage, 'product-configuration-cache:') },
  );
};
